"use client";

export { default as GlobalEventEmitter } from "GlobalEventEmitter"